import React from 'react'

import './style.scss'

const UseCase = props => (
  <div className="use-case">
    {props.do && (
      <div className="use-case__item">
        <span className="use-case__item--do">Do</span>
        {props.do}
      </div>
    )}

    {props.dont && (
      <div className="use-case__item">
        <span className="use-case__item--dont">Don’t</span>
        {props.dont}
      </div>
    )}
  </div>
)

export default UseCase
